import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '~/store'
import { removeFlashMessage, type FlashMessage } from '~/store/flashMessageSlice'
import { BetterToast } from '~/utils/toast'

export function FlashMessageHandler(): null {
  const dispatch = useDispatch()
  const messages = useSelector((state: RootState) => state.flashMessage.messages)

  useEffect(() => {
    // Show each message as a toast and then remove it from Redux
    messages.forEach((message: FlashMessage) => {
      // Show the toast
      if (message.type === 'success') {
        BetterToast.success(message.message)
      } else if (message.type === 'error') {
        BetterToast.error(message.message)
      } else if (message.type === 'info') {
        BetterToast.success(message.message) // Use success style for info for now
      }

      // Remove the message from Redux after showing it
      dispatch(removeFlashMessage(message.id))
    })
  }, [messages, dispatch])

  // This component doesn't render anything, it just handles side effects
  return null
}
